import LayerGroup from "ol/layer/Group";
import LayerTile from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";

const karagatanURL = process.env.GEOSERVER;
const attEOG =
  '<a href="https://eogdata.mines.edu/vbd/">Earth Observation Group, Payne Institute for Public Policy</a>';

const iuuf_2026Q2 = new LayerGroup({
  title: "2026 Q2",
  fold: "close",
  layers: [
    ///////////monthly
    new LayerTile({
      title: "Triple/Quadruple Nets",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_TripleQuadrupleNets",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Superlight",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_Superlight",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Sand quarrying",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_SandQuarrying",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Ring Net (Likom-Likom/Basnig)",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_RingNet",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Obnoxious Substances",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_ObnoxiousSubstances",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Muro-ami",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_Muroami",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Modified Danish Seine (Liba-Liba)",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_ModifiedDanishSeine",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Mangrove Cutting",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_MangroveCutting",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Illegal Structures in the Shoreline",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_IllegalStructuresInTheShoreline",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Fishing Inside Marine Sanctuary",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_FishingInsideMarineSanctuary",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Fine Mesh Net Fishing",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_FineMeshNetFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Dynamite Fishing",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_DynamiteFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Danish Seine (Buli-buli)",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_DanishSeine",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Coral Extraction",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_CoralExtraction",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Compressor Fishing",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_CompressorFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Bottom Trawling",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_BottomTrawling",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Blast Fishing",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_BlastFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Bagnet",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_Q2_Bagnet",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
  ],
});

export default iuuf_2026Q2;
